export default __webpack_public_path__ + "307b167b31484acb644272d0ff065bc6.png";